import { useEffect, useRef } from 'react';
import cx from 'classnames';

import style from './C3Chart.scss';

const generateChart = async (element, data, options = {}) => {
  await import('c3/c3.min.css');
  // webpackChunkName: 'c3' needs to be inside import
  // See: https://webpack.js.org/api/module-methods/#magic-comments
  const _ = await import(/* webpackChunkName: 'c3' */ 'c3');
  const c3 = _.default;

  return c3.generate({
    bindto: element,
    data: { ...data },
    ...options,
  });
};
/* eslint-disable react/prop-types */ // TODO: add props

const C3Chart = ({ data, options, className }) => {
  const chartElement = useRef(null);

  useEffect(() => {
    async function doChart() {
      await generateChart(chartElement.current, data, options);
    }
    doChart();
  }, [data, options]);

  return (
    <div ref={chartElement} className={cx(style.chartContainer, className)} />
  );
};

export default C3Chart;
